import React, { useRef, useEffect, useState } from "react";
import { useFormik } from "formik";
import { Button, Spin2, Collapse } from "components";
import { validationSchema, initialValues } from "../components/common";
import { Main, Payment, Additional, Pricing, Product, Discord, Telegram } from "../components";
import { toastAlert } from "@paylixecommerce/shared/components";
import { useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router";
import { editProduct, getProductByID } from "../../actions";
import includes from "lodash/includes";
import config from "constants/config";
import getCDNLink from "constants/cdn-link";
import { Tooltip } from "@paylixecommerce/shared/components";
import moment from "moment";
import { ChevronUp, ChevronDown } from "../../../../../layouts/dashboard/sidebar/icons/icons/icons";
import useMobile from "../../../../../../../hooks/useMobile";
import ClosePage from "../components/save-close";

import "../components/style.scss";

export const TipsIcon = () => <svg className="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                   xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8H2.66667M8 2V2.66667M13.3333 8H14M3.73333 3.73333L4.2 4.2M12.2667 3.73333L11.8 4.2"
          stroke="var(--purple6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path
        d="M5.99984 10.668C5.44015 10.2482 5.02673 9.66298 4.81813 8.99519C4.60952 8.32741 4.61632 7.61092 4.83756 6.94721C5.0588 6.2835 5.48325 5.70623 6.0508 5.29716C6.61835 4.88809 7.30023 4.66797 7.99984 4.66797C8.69945 4.66797 9.38132 4.88809 9.94887 5.29716C10.5164 5.70623 10.9409 6.2835 11.1621 6.94721C11.3833 7.61092 11.3901 8.32741 11.1815 8.99519C10.9729 9.66298 10.5595 10.2482 9.99984 10.668C9.73955 10.9256 9.54357 11.2409 9.42775 11.5884C9.31193 11.9358 9.27953 12.3057 9.33317 12.668C9.33317 13.0216 9.19269 13.3607 8.94265 13.6108C8.6926 13.8608 8.35346 14.0013 7.99984 14.0013C7.64622 14.0013 7.30708 13.8608 7.05703 13.6108C6.80698 13.3607 6.6665 13.0216 6.6665 12.668C6.72014 12.3057 6.68774 11.9358 6.57192 11.5884C6.45611 11.2409 6.26013 10.9256 5.99984 10.668Z"
        stroke="var(--purple6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.4668 11.332H9.53346" stroke="var(--purple6)" strokeWidth="1.5" strokeLinecap="round"
          strokeLinejoin="round"/>
</svg>;


export const NotFoundIcon = () => <svg width="180" height="180" viewBox="0 0 180 180" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
    <circle cx="90" cy="90" r="90" fill="#F5F7F8"/>
    <path
        d="M164.3 145.9V149.8C164.3 153.3 161.3 156.2 157.6 156.2H22.7C19 156.2 16 153.3 16 149.8V145.9H77C77.5 147.3 78.9 148.4 80.6 148.4H99.7C101.4 148.4 102.8 147.4 103.3 145.9H164.3Z"
        fill="#777F89"/>
    <path
        d="M164.3 145.9C164.3 149.4 161.3 152.2 157.6 152.2H22.7C19 152.2 16 149.4 16 145.9H77C77.5 147.3 78.9 148.4 80.6 148.4H99.7C101.4 148.4 102.8 147.4 103.3 145.9H164.3Z"
        fill="#A2AAB4"/>
    <path
        d="M156.7 145.9H23.7002V61.6998C23.7002 58.9998 25.9002 56.7998 28.6002 56.7998H151.9C154.6 56.7998 156.8 58.9998 156.8 61.6998L156.7 145.9Z"
        fill="#DFE5E9"/>
    <path d="M123.6 146.2H29.8999V63.7998H150V146.2H137.4" fill="white"/>
    <path
        d="M59.7077 129.9H38.6927C37.8569 129.9 37.2002 128.8 37.2002 127.4C37.2002 126 37.8569 124.9 38.6927 124.9H59.7077C60.5435 124.9 61.2002 126 61.2002 127.4C61.2002 128.8 60.5435 129.9 59.7077 129.9Z"
        fill="#E9EDF0"/>
    <path
        d="M52.1558 118H39.2446C38.3797 118 37.7002 116.9 37.7002 115.5C37.7002 114.1 38.3797 113 39.2446 113H52.1558C53.0207 113 53.7002 114.1 53.7002 115.5C53.7002 116.9 53.0207 118 52.1558 118Z"
        fill="#E9EDF0"/>
    <path
        d="M65.2002 84.3999H40.7002C39.3002 84.3999 38.2002 83.2999 38.2002 81.8999C38.2002 80.4999 39.3002 79.3999 40.7002 79.3999H65.2002C66.6002 79.3999 67.7002 80.4999 67.7002 81.8999C67.7002 83.2999 66.6002 84.3999 65.2002 84.3999Z"
        fill="#E9EDF0"/>
    <path
        d="M57.3002 94.7998H40.7002C39.3002 94.7998 38.2002 93.6998 38.2002 92.2998C38.2002 90.8998 39.3002 89.7998 40.7002 89.7998H57.3002C58.7002 89.7998 59.8002 90.8998 59.8002 92.2998C59.8002 93.6998 58.6002 94.7998 57.3002 94.7998Z"
        fill="#E9EDF0"/>
    <path
        d="M70.1567 32.1567C60.6144 41.699 60.6144 57.233 70.1567 66.7753C79.699 76.3176 95.2329 76.3176 104.775 66.7753C114.318 57.233 114.318 41.699 104.775 32.1567C95.1886 22.6144 79.699 22.6144 70.1567 32.1567Z"
        fill="white"/>
    <path
        d="M70.1567 32.1567C60.6144 41.699 60.6144 57.233 70.1567 66.7753C79.699 76.3176 95.2329 76.3176 104.775 66.7753C114.318 57.233 114.318 41.699 104.775 32.1567C95.1886 22.6144 79.699 22.6144 70.1567 32.1567ZM101.668 63.6685C93.8127 71.5243 81.0749 71.5243 73.2191 63.6685C65.3634 55.8128 65.3634 43.0749 73.2191 35.2191C81.0749 27.3634 93.8127 27.3634 101.668 35.2191C109.524 43.1193 109.524 55.8128 101.668 63.6685Z"
        fill="#A2AAB4"/>
    <path d="M118.712 76.0958L114.273 80.5785L101.402 67.885L105.841 63.4023L118.712 76.0958Z" fill="#777F89"/>
    <path
        d="M125.68 87.5022C123.682 89.4994 120.487 89.4994 118.49 87.5022L103.977 73.1666L111.167 65.9766L125.68 80.3122C127.633 82.3094 127.633 85.505 125.68 87.5022Z"
        fill="#A2AAB4"/>
    <path
        d="M70.3709 112.92V102.56L66.0109 112.92H70.3709ZM61.9709 112.92L69.9709 94H74.7709V112.92H76.8509V116.92H74.7709V122H70.3709V116.92H61.9709V112.92ZM83.3103 100.72C83.3103 98.4533 83.8836 96.72 85.0303 95.52C86.177 94.2933 87.8303 93.68 89.9903 93.68C92.1503 93.68 93.8036 94.2933 94.9503 95.52C96.097 96.72 96.6703 98.4533 96.6703 100.72V115.28C96.6703 117.547 96.097 119.293 94.9503 120.52C93.8036 121.72 92.1503 122.32 89.9903 122.32C87.8303 122.32 86.177 121.72 85.0303 120.52C83.8836 119.293 83.3103 117.547 83.3103 115.28V100.72ZM87.7103 115.56C87.7103 116.573 87.9103 117.293 88.3103 117.72C88.737 118.12 89.297 118.32 89.9903 118.32C90.6836 118.32 91.2303 118.12 91.6303 117.72C92.057 117.293 92.2703 116.573 92.2703 115.56V100.44C92.2703 99.4267 92.057 98.72 91.6303 98.32C91.2303 97.8933 90.6836 97.68 89.9903 97.68C89.297 97.68 88.737 97.8933 88.3103 98.32C87.9103 98.72 87.7103 99.4267 87.7103 100.44V115.56ZM111.69 112.92V102.56L107.33 112.92H111.69ZM103.29 112.92L111.29 94H116.09V112.92H118.17V116.92H116.09V122H111.69V116.92H103.29V112.92Z"
        fill="#A2AAB4"/>
</svg>;


const EditProduct = ({ isAdmin }) => {

    const [gateways, setGateways] = useState({});
    const [delimiter, setDelimiter] = useState(config.DELIMITER_OPTIONS[0].value);
    const [created, setCreated] = useState(false);
    const isMobile = useMobile();

    const [closeConfirmModal, setShowConfirmModal] = useState(false);

    const [volumeDiscounts, setVolumeDiscounts] = useState([]);
    const [customFields, setCustomFields] = useState([]);
    const [webhooks, setWebhooks] = useState([]);
    const [progress, setProgress] = useState(0);
    const [discordServerError, setDiscordServerError] = useState("");
    const [telegramServerError, setTelegramServerError] = useState("");

    const [generalInfo, showGeneralInfo] = useState(true);
    const [pricingInfo, showPricingInfo] = useState(false);
    const [paymentInfo, showPaymentInfo] = useState(false);
    const [productInfo, showProductInfo] = useState(false);
    const [discordInfo, showDiscordInfo] = useState(false);
    const [telegramInfo, showTelegramInfo] = useState(false);
    const [additionalInfo, showAdditionalInfo] = useState(false);


    const [initial, setInitialValues] = useState(initialValues);

    const [removedImages, setRemovedImages] = useState([]);
    const [removedFiles, setRemovedFiles] = useState([]);

    const [save, setSave] = useState(false);
    const [loading, setLoading] = useState(true);
    const [product, setProduct] = useState(null);
    const [notFound, setNotFound] = useState(null);
    const {id, name: shopName} = useParams();

    const generalInfoRef = useRef(null);
    const generalInfoScroll = () => {
        setTimeout(() => {
            generalInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const pricingInfoRef = useRef(null);
    const pricingInfoScroll = () => {
        setTimeout(() => {
            pricingInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const paymentInfoRef = useRef(null);
    const paymentInfoScroll = () => {
        setTimeout(() => {
            paymentInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const productInfoRef = useRef(null);
    const productInfoScroll = () => {
        setTimeout(() => {
            productInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const additionalInfoRef = useRef(null);
    const additionalInfoScroll = () => {
        setTimeout(() => {
            additionalInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const discordInfoRef = useRef(null);
    const discordInfoScroll = () => {
        setTimeout(() => {
            discordInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };
    const telegramInfoRef = useRef(null);
    const telegramInfoScroll = () => {
        setTimeout(() => {
            telegramInfoRef.current.scrollIntoView({behavior: 'smooth'})
        }, 500)
    };

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {

        if (location.state && location.state.isSerials) {
            showGeneralInfo(false);
            showProductInfo(true);
            productInfoScroll();
        }

    }, [location.state])

    const configs = {
        onUploadProgress: progressEvent => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
        }
    }

    const getProduct = () => {
        dispatch(getProductByID(id))
            .then(res => {
                if (res.status === 404) {
                    setProduct(null);
                    setNotFound(true);
                } else {
                    setProduct(res.data.product);
                }
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        if (id) {
            getProduct();
        }
    }, [id])

    const onSubmit = (values, {setErrors}) => {

        setCreated(true);

        if (values.manuallyWarranty && +values.manuallyWarranty < 900) {
            setErrors({
                manuallyWarranty: "Must be more then 900 seconds"
            });
            return;
        }

        const admin = includes(location.pathname, 'admin');

        let data = {...values};

        data.gateways = Object.keys(gateways).filter(key => gateways[key] && key.trim()).join(',');
        data.custom_fields = JSON.stringify({
            custom_fields: customFields.map(field => ({...field, type: field.type}))
        });
        data.volume_discounts = JSON.stringify({volume_discounts: volumeDiscounts});
        data.stock = values.showStock ? data.stock : -1;
        data.subtype = values.subtype || "";
        data.price_discount = +values.price_discount;
        if (!data.price_discount_enabled) {
            data.price_discount = null;
        }

        data.redirect_link = data.redirect_enabled ? (values.redirect_link || "") : "";
        data.delivery_text = data.delivery_text_enabled ? (values.delivery_text || "") : "";
        data.affiliate_revenue_percent = values.affiliate_revenue_percent;

        data.watermark_enabled = values.watermark_enabled;
        data.watermark_text = values.watermark_text;

        if (data.quantity_max === "" || data.quantity_max === 0 || data.quantity_max === 0) {
            data.quantity_max = "0";
        }

        if (data.stock_delimiter === "↵") {
            data.stock_delimiter = "\n"
        }

        let warranty = values.warranty;

        if (values.warranty === "1") {
            warranty = values.manuallyWarranty;
            delete values.manuallyWarranty;
        }

        data.warranty = warranty;

        if (removedImages.length) {
            data.remove_images_uniqids = removedImages;
        }

        if (removedFiles.length) {
            data.remove_files_uniqids = removedFiles;
        }

        data.currency = typeof data.currency === "string" ? data.currency : data.currency.value;

        data.webhooks = webhooks;
        data.unlisted = Boolean(data.unlisted);
        data.private = Boolean(data.private);
        data.block_vpn_proxies = Boolean(data.block_vpn_proxies);
        data.on_hold = Boolean(data.on_hold);
        data.pay_what_you_want = Boolean(+data.pay_what_you_want);
        data.licensing_enabled = Boolean(values.licensing_enabled) || false;

        if (data.licensing_enabled) {
            data.license_period = +values.license_period;
        }

        data.serials_remove_duplicates = values.removeDuplicates;

        data.file = data.file.map(v => {
            if (v.size) {
                return v
            } else {
                return null
            }
        }).filter((i) => i);

        data.image = data.image.map(v => {
            if (v.size) {
                return v
            } else {
                return null
            }
        }).filter((i) => i);

        data.image.forEach(({lastModified}, key) => {
            if (lastModified === data.default_image) {
                data.default_image = key;
            }
        });

        if (!data.default_image && data.default_image !== 0) {
            data.default_image = 0
        }

        if (data.default_image && data.default_image.length > 10) {
            if (data.image_attachments) {
                data.image_attachments.forEach(({uniqid, cloudflare_image_id}) => {
                    if (data.default_image === cloudflare_image_id) {
                        data.default_image = uniqid;
                    }
                })
            }
        }

        delete data.file_attachment;
        delete data.redirect_enabled;
        delete data.warranty_enabled;
        delete data.tos_enabled;
        delete data.delivery_text_enabled;
        delete data.price_discount_enabled;
        delete data.file_attachment_info;
        delete data.file_attachments;
        delete data.removeDuplicates;
        delete data.affiliate_revenue_enabled;

        delete data.image_attachments;
        delete data.image_attachment;
        delete data.image_attachment_info;

        delete data.feedback;
        delete data.price_conversions;

        data.discord_integration = Boolean(data.discord_integration);

        if (data.discord_integration) {
            data.discord_server_id = data.discord_server_id || "none";
            data.discord_set_role = Boolean(data.discord_set_role);
            data.discord_optional = Boolean(data.discord_optional);
            data.discord_role_id = data.discord_role_id || "";
            data.discord_remove_role = Boolean(data.discord_remove_role);
        } else {
            data.discord_optional = false;
            data.discord_server_id = "none";
            data.discord_set_role = false;
            data.discord_role_id = "";
            data.discord_remove_role = false;
        }

        data.telegram_integration = !!data.telegram_integration;
        if (data.telegram_integration) {
            data.telegram_group_id = data.telegram_group_id || "none";
            data.telegram_optional = !!data.telegram_optional;
        } else {
            data.telegram_group_id = "none";
            data.telegram_optional = false;
        }

        setSave(true);

        return dispatch(editProduct(data, configs))
            .then(res => {
                if (admin) {
                    history.goBack();
                    setProgress(0);
                } else {
                    getProduct();
                    setProgress(0);
                }
                toastAlert('success', res.message);
            })
            .catch(err => {
                toastAlert('error', err ? err.error : "");
                setProgress(0);
            })
            .finally(() => {
                setCreated(false);
                setProgress(0);
            })
    };

    useEffect(() => {

        let isAdmin = window.location.origin.includes('admin');

        if (product && product.type === "INFO_CARD") {
            if (isAdmin) {
                history.push(`/tools/users/${shopName}/products/edit/info/${product.uniqid}`);
            } else {
                history.push(`/products/edit/info/${product.uniqid}`);
            }
            return;
        }

        if (product && product.price_variants && product.price_variants.length) {
            if (isAdmin) {
                history.push(`/tools/users/${shopName}/products/edit/variant/${product.uniqid}`);
            } else {
                history.push(`/products/edit/variant/${product.uniqid}`);
            }
            return;
        }

        if (product) {
            let gateways = {};
            let custom_fields = [];

            let volume_discounts = [];

            if (product && product.volume_discounts) {
                try {
                    volume_discounts = JSON.parse(product.volume_discounts).volume_discounts;
                } catch (e) {
                }
            }

            if (product && product.custom_fields) {
                try {
                    custom_fields = JSON.parse(product.custom_fields).custom_fields;
                } catch (e) {
                }
            }

            let type = config.TYPE_OPTIONS.filter(type => type.value === product.type);

            custom_fields = custom_fields.map(field => {
                let c_type = config.CUSTOM_TYPE.filter(type => type.value === field.type);
                return {...field, type: c_type[0] || "text"}
            });

            let options = product.gateways.split(',').filter(g => g && g.trim());

            if (options.length) {

                options = options
                    .map(g => g.split(":")[0])
                    .filter((g, index, self) => self.indexOf(g) === index);

                if (options.some(g => g.includes("USDC"))) {
                    gateways["USDC"] = true;
                }
                if (options.some(g => g.includes("USDC_NATIVE"))) {
                    gateways["USDC_NATIVE"] = true;
                }
                if (options.some(g => g.includes("USDT"))) {
                    gateways["USDT"] = true;
                }
                if (options.some(g => g.includes("PLZ"))) {
                    gateways["PLZ"] = true;
                }
                if (options.some(g => g.includes("SHIB"))) {
                    gateways["SHIB"] = true;
                }
                if (options.some(g => g.includes("DAI"))) {
                    gateways["DAI"] = true;
                }
                if (options.some(g => g.includes("APE"))) {
                    gateways["APE"] = true;
                }
                if (options.some(g => g.includes("PEPE"))) {
                    gateways["PEPE"] = true;
                }
                if (options.some(g => g.includes("WETH"))) {
                    gateways["WETH"] = true;
                }
                options.map(key => gateways[key] = true);
            }

            let delimiter = product.stock_delimiter === ',' ?
                config.DELIMITER_OPTIONS[0] :
                product.stock_delimiter === '\n' ?
                    config.DELIMITER_OPTIONS[1] :
                    escape(product.stock_delimiter) === '%0D%0A' ?
                        config.DELIMITER_OPTIONS[1] :
                        config.DELIMITER_OPTIONS[2];

            if (escape(product.stock_delimiter) === "%0D%0A") {
                product.stock_delimiter = '\n'
            }

            product.serials = product.serials ? product.serials.join(product.stock_delimiter) : ""
            product.price = product.price_display;

            if (product.warranty === null) {
                product.warranty = '0'
            }

            let warranty = config.WARRANTY_OPTIONS.find(({value}) => value === product.warranty.toString());


            let file = () => {
                if (product.file_attachments && product.file_attachments.length) {
                    return product.file_attachments.map(i => ({
                        id: i.uniqid,
                        size: i.size ? i.size : null,
                        name: i.original_name,
                        uniqid: i.uniqid
                    }))
                } else {
                    return [];
                }
            };

            let image = () => {

                if (product.image_attachments && product.image_attachments.length) {
                    return product.image_attachments.map(i => ({
                        preview: i.cloudflare_image_id ? getCDNLink({
                            id: i.cloudflare_image_id,
                            type: "shopItem"
                        }) : null,
                        size: i.size ? i.size : null,
                        date: i.created_at ? moment(i.created_at * 1000).format('DD, MMM YYYY HH:mm') : null,
                        name: i.original_name ? i.original_name : '',
                        uniqid: i.uniqid
                    }))
                } else {
                    return [];
                }
            }

            setInitialValues({
                ...product,
                license_period: product.licensing_enabled ? product.license_period : null,
                block_vpn_proxies: !!+product.block_vpn_proxies,
                slug: product.slug || product.uniqid,
                max_risk_level: product.max_risk_level || 85,
                trial_period: product.trial_period || 0,
                removeDuplicates: product.licensing_enabled,
                default_image: product.image_attachment || "",
                redirect_link: product.redirect_link || "",
                youtube_link: product.youtube_link || "",
                price_discount_enabled: +product.price_discount > 0,
                price_discount: +product.price_discount,
                currency: Object.values(config.CURRENCY_OPTIONS).find(({ key }) => key === product.currency)?.key ?? null,
                warranty: product.warranty.toString() && warranty ? warranty.value.toString() : "1",
                manuallyWarranty: product.warranty.toString() && !warranty ? product.warranty.toString() : null,
                terms_of_service: product.terms_of_service || "",
                label_singular: product.label_singular || "",
                label_plural: product.label_plural || "",
                tos_enabled: !!product.terms_of_service,
                type: type[0].value,
                showStock: product.stock !== -1,
                subtype: product.subtype,
                discord_optional: !!+product.discord_optional,
                discord_server_id: product.discord_server_id || "none",
                telegram_optional: !!+product.telegram_optional,
                telegram_group_id: product.telegram_group_id || "none",
                watermark_enabled: product.watermark_enabled,
                redirect_enabled: product.redirect_link,
                warranty_enabled: (product.warranty.toString() && warranty) || (product.warranty.toString() && !warranty),
                delivery_text_enabled: product.delivery_text,
                watermark_text: product.watermark_text,
                affiliate_revenue_enabled: product.affiliate_revenue_percent > 0,
                affiliate_revenue_percent: product.affiliate_revenue_percent,
                file: file(),
                image: image(),
                recurring_interval: product.recurring_interval || "DAY",
                recurring_interval_count: product.recurring_interval_count || 7
            });

            setDelimiter(delimiter.value)
            setGateways(gateways)
            setCustomFields(custom_fields)
            setVolumeDiscounts(volume_discounts)
            setWebhooks(product.webhooks)

        }

    }, [product, shopName]);

    let form = useFormik({
        validationSchema,
        enableReinitialize: true,
        initialValues: initial,
        onSubmit
    });


    useEffect(() => {
        if (form.values.discord_server_id && form.values.discord_server_id !== "none") {
            setDiscordServerError("");
        }
    }, [form.values.discord_server_id]);

    useEffect(() => {
        if (form.values.telegram_group_id && form.values.telegram_group_id !== "none") {
            setTelegramServerError("");
        }
    }, [form.values.telegram_group_id]);


    if (notFound) {
        return <>
            <div className="edit-modal-body d-flex align-items-center justify-content-center flex-column">

                <NotFoundIcon/>
                <div style={{fontSize: 24, fontWeight: 600, color: "var(--black9)"}} className="mt-3 mb-2">Product Not
                    Found
                </div>
                <div style={{fontSize: 14, color: "var(--black9)"}}>The product with ID <span
                    style={{fontWeight: 500}}>{id}</span> could not be found.
                </div>

            </div>

            <div className="edit-modal-footer">
                <Button type="button" size="large" variant="secondary" className="w-100" onClick={() => history.push(isAdmin ? isAdmin : '/products')}>
                    Close
                </Button>
            </div>
        </>
    }

    return <>

        <div className="edit-modal-header" style={{borderBottom: "none"}}>
            <div className="edit-modal-header-title">Edit Product</div>
            <div className="edit-modal-header-ref">/{form.values.slug}</div>
        </div>

        <div className="edit-modal-body">

            <form onSubmit={form.handleSubmit} className="product-form mb-0">

                <div className="product-progress" style={{width: `${progress}%`}}/>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={generalInfoRef}
                         onClick={() => {
                             if (isMobile) {
                                 showPricingInfo(false);
                                 showProductInfo(false);
                                 showPaymentInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }

                             if (!generalInfo) {
                                 generalInfoScroll();
                             }

                             showGeneralInfo(!generalInfo);
                         }}
                    >
                        <div className="d-flex">
                            {generalInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>General Info</span>
                        </div>
                    </div>
                    <Collapse isOpen={generalInfo}>
                        <Main form={form} removeImage={(id) => setRemovedImages([...removedImages, id])}/>
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={pricingInfoRef}
                         onClick={() => {
                             if (isMobile) {
                                 showGeneralInfo(false);
                                 showProductInfo(false);
                                 showPaymentInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }
                             if (!pricingInfo) {
                                 pricingInfoScroll();
                             }
                             showPricingInfo(!pricingInfo);
                         }}
                    >
                        <div className="d-flex">
                            {pricingInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Pricing</span>
                        </div>
                    </div>
                    <Collapse isOpen={pricingInfo}>
                        <Pricing form={form}/>
                    </Collapse>
                </div>


                <div className="product-block">
                    <div className="product-block-header"
                         ref={productInfoRef}
                         onClick={() => {
                             if (isMobile) {
                                 showGeneralInfo(false);
                                 showPricingInfo(false);
                                 showPaymentInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }
                             if (!productInfo) {
                                 productInfoScroll();
                             }
                             showProductInfo(!productInfo);
                         }}
                    >
                        <div className="d-flex">
                            {productInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Product</span>
                        </div>
                    </div>
                    <Collapse isOpen={productInfo}>
                        <Product form={form} delimiter={delimiter} setDelimiter={setDelimiter}
                                 removeFile={(id) => setRemovedFiles([...removedFiles, id])}/>
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={paymentInfoRef}
                         onClick={() => {
                             if (isMobile) {
                                 showGeneralInfo(false);
                                 showPricingInfo(false);
                                 showProductInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }
                             if (!paymentInfo) {
                                 paymentInfoScroll();
                             }
                             showPaymentInfo(!paymentInfo);
                         }}
                    >
                        <div className="d-flex">
                            {paymentInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Payment Methods</span>
                        </div>
                    </div>
                    <Collapse isOpen={paymentInfo}>
                        <div className="product-form-main-back pb-0">
                            <Payment setGateways={setGateways} gateways={gateways}/>
                        </div>
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={discordInfoRef}
                         onClick={() => {
                             if (isMobile) {
                                 showGeneralInfo(false);
                                 showPricingInfo(false);
                                 showPaymentInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                             }

                             if (!discordInfo) {
                                 discordInfoScroll();
                             }
                             showDiscordInfo(!discordInfo);
                         }}
                    >
                        <div className="d-flex">
                            {discordInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Discord Integration</span>
                        </div>

                        <div className="product-block-header-optional">Optional</div>
                    </div>
                    <Collapse isOpen={discordInfo}>
                        <Discord form={form} discordServerError={discordServerError}/>
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={telegramInfoRef}
                         onClick={() => {
                             if (isMobile) {
                                 showGeneralInfo(false);
                                 showPricingInfo(false);
                                 showPaymentInfo(false);
                                 showAdditionalInfo(false);
                                 showDiscordInfo(false);
                                 showTelegramInfo(false);
                             }

                             if (!telegramInfo) {
                                 telegramInfoScroll();
                             }
                             showTelegramInfo(!telegramInfo);
                         }}
                    >
                        <div className="d-flex">
                            {telegramInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span>Telegram Integration</span>
                        </div>

                        <div className="product-block-header-optional">Optional</div>
                    </div>
                    <Collapse isOpen={telegramInfo}>
                        <Telegram form={form} telegramServerError={telegramServerError}/>
                    </Collapse>
                </div>

                <div className="product-block">
                    <div className="product-block-header"
                         ref={additionalInfoRef}
                         onClick={(e) => {
                             if (e.target.tagName === 'A') {
                                 return ""
                             } else {
                                 if (isMobile) {
                                     showGeneralInfo(false);
                                     showPricingInfo(false);
                                     showProductInfo(false);
                                     showPaymentInfo(false);
                                     showDiscordInfo(false);
                                     showTelegramInfo(false);
                                 }

                                 if (!additionalInfo) {
                                     additionalInfoScroll();
                                 }

                                 showAdditionalInfo(!additionalInfo);
                             }
                         }}
                    >
                        <div className="d-flex">
                            {additionalInfo ? <ChevronUp/> : <ChevronDown/>}
                            <span className="d-flex">
                                Additional Details
                                <Tooltip name="extra-info" tooltipText={`Go to Products -> Utils in your sidebar to update multiple products at once.`} className="d-flex align-items-center justify-content-center color-purple">
                                    <Link to="/utils" target="_blank" className="ml-3 badge badge-paylixecommerce">
                                        <TipsIcon/> Did You Know?
                                    </Link>
                                </Tooltip>
                            </span>
                        </div>

                        <div className="product-block-header-optional">Optional</div>
                    </div>
                    <Collapse isOpen={additionalInfo}>
                        <Additional
                            form={form}
                            volumeDiscounts={volumeDiscounts}
                            setVolumeDiscounts={setVolumeDiscounts}
                            customFields={customFields}
                            setCustomFields={setCustomFields}
                            webhooks={webhooks}
                            setWebhooks={setWebhooks}
                            gateways={gateways}
                        />
                    </Collapse>
                </div>

            </form>

        </div>


        <ClosePage to="/products" open={closeConfirmModal} close={() => setShowConfirmModal(false)}/>
        <div className="edit-modal-footer">
            <Button type="button" size="large" disabled={created} variant="secondary" onClick={() => {
                if (form.dirty) {
                    setShowConfirmModal(true);
                } else {
                    history.push(isAdmin ? isAdmin : '/products');
                }
            }}>
                {form.dirty ? "Cancel" : "Close"}
            </Button>
            <Button type="submit" size="large" disabled={created} onClick={() => {
                if (form.values.discord_integration && (!form.values.discord_server_id || form.values.discord_server_id === "none")) {
                    if (isMobile) {
                        showDiscordInfo(true);
                    }

                    if (!discordInfo) {
                        discordInfoScroll();
                    }

                    setDiscordServerError("You need to select a server if you want to use Discord")

                    showDiscordInfo(true);

                } else if (form.values.telegram_integration && (!form.values.telegram_group_id || form.values.telegram_group_id === "none")) {
                        if (isMobile) {
                            showTelegramInfo(true);
                        }

                        if (!telegramInfo) {
                            telegramInfoScroll();
                        }

                        setTelegramServerError("You need to select a group if you want to use Telegram")

                        showTelegramInfo(true);

                } else {
                    form.handleSubmit();
                }
            }}>
                {created ? <Spin2/> : `Update Product`}
            </Button>
        </div>

    </>
}

export default EditProduct;
